if (!customElements.get('bundle-steps')) {
  customElements.define(
    'bundle-steps',
    class BundleSteps extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        // product-form.js unconditionally re-enables the hidden variant-id input on load.
        // This component must run after that (both scripts are deferred, and product-form.js
        // is included earlier in the section) so it can re-apply the disabled/pending state
        // until a full bundle selection is made.
        this.variantInput = this.form ? this.form.querySelector('.product-variant-id') : null;
        this.submitButton = this.form ? this.form.querySelector('button[type="submit"]') : null;
        this.variants = JSON.parse(this.querySelector('[data-bundle-variants]').textContent);
        this.steps = Array.from(this.querySelectorAll('[data-step]'));

        this.steps.forEach((step) => {
          const toggle = step.querySelector('[data-step-toggle]');
          if (toggle) toggle.addEventListener('click', () => this.openStep(step));
          const reset = step.querySelector('[data-step-reset]');
          if (reset) reset.addEventListener('click', () => this.resetStep(step));
        });
        this.addEventListener('change', (event) => {
          if (event.target.matches('input[type="radio"]')) this.update();
        });

        this.update();
        // после update() у опций уже проставлен disabled — выбираем первые доступные
        this.autoSelectDefaults();
      }

      autoSelectDefaults() {
        this.querySelectorAll('[data-option-index]').forEach((group) => {
          if (group.querySelector('input:checked')) return;
          const first = Array.from(group.querySelectorAll('input[type="radio"]')).find((input) => !input.disabled);
          if (first) {
            first.checked = true;
            this.update();
          }
        });
      }

      openStep(step) {
        step.querySelector('[data-step-options]').hidden = false;
        const toggle = step.querySelector('[data-step-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
        step.classList.add('is-selected');
        this.update();
      }

      resetStep(step) {
        step.querySelectorAll('input[type="radio"]').forEach((input) => (input.checked = false));
        step.querySelector('[data-step-options]').hidden = true;
        const toggle = step.querySelector('[data-step-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        step.classList.remove('is-selected');
        this.update();
      }

      selectedOptions() {
        const options = [];
        this.querySelectorAll('[data-option-index]').forEach((group) => {
          const checked = group.querySelector('input:checked');
          options[Number(group.dataset.optionIndex)] = checked ? checked.value : null;
        });
        return options;
      }

      matchingVariant(options) {
        return this.variants.find((variant) =>
          variant.options.every((value, index) => options[index] === value)
        );
      }

      updateAvailability(options) {
        this.querySelectorAll('[data-option-index]').forEach((group) => {
          const index = Number(group.dataset.optionIndex);
          group.querySelectorAll('input[type="radio"]').forEach((input) => {
            const candidate = options.slice();
            candidate[index] = input.value;
            const hasAvailable = this.variants.some(
              (variant) =>
                variant.available &&
                variant.options.every(
                  (value, i) => candidate[i] === null || candidate[i] === value
                )
            );
            input.disabled = !hasAvailable;
          });
        });
      }

      update() {
        const options = this.selectedOptions();
        this.updateAvailability(options);

        this.steps.forEach((step) => {
          const hasChecked = !!step.querySelector('input:checked');
          const isOpen = !step.querySelector('[data-step-options]').hidden;
          step.classList.toggle('is-selected', hasChecked || isOpen);
          const reset = step.querySelector('[data-step-reset]');
          if (reset) reset.hidden = !hasChecked;
        });
        this.classList.toggle(
          'has-selection',
          this.steps.some((step) => step.querySelector('input:checked'))
        );

        const complete = options.length > 0 && options.every((value) => value !== null);
        const variant = complete ? this.matchingVariant(options) : null;

        if (variant && variant.available) {
          if (this.variantInput) {
            this.variantInput.value = variant.id;
            this.variantInput.disabled = false;
          }
          if (this.submitButton) {
            this.submitButton.disabled = false;
            this.submitButton.classList.remove('button--bundle-pending');
          }
          this.updatePrice(variant);
        } else {
          if (this.variantInput) {
            this.variantInput.value = '';
            this.variantInput.disabled = true;
          }
          if (this.submitButton) {
            this.submitButton.disabled = true;
            this.submitButton.classList.add('button--bundle-pending');
          }
        }
      }

      updatePrice(variant) {
        const section = this.closest('product-info') || document;
        const priceEl = section.querySelector('.price__regular .price-item--regular');
        if (priceEl && variant.price_formatted) priceEl.textContent = variant.price_formatted;
      }
    }
  );
}
